module.exports = __webpack_public_path__ + "static/media/courses.d8978565.svg";